import { useArtworkImage } from "@design-lab/entities/artwork";
import { TabNavigation } from "@design-lab/shared/ui";
import type { MenuId } from "../../model/state";
import { MENU_IDS } from "../../model/state";
import { SHIRT_TAB_IDS } from "../../model/types/TabTypes";
import { useShirtTabs } from "../../model/useShirtTabs";
import { AiDesignContent } from "./AiDesignContent";
import { CommunityArtContent } from "./CommunityArtContent";
import { LibraryContent } from "./LibraryContent";
import { UploadContent } from "./UploadContent";
import { VectorArtsContent } from "./VectorArtsContent";

type MainContentProps = {
  activeMenu: MenuId;
};

export function MainContent({ activeMenu }: MainContentProps) {
  const { tabs, activeTab, handleTabChange } = useShirtTabs();
  const { uploadArtwork, deleteArtwork } = useArtworkImage();

  const currentSide = activeTab === SHIRT_TAB_IDS.BACK ? SHIRT_TAB_IDS.BACK : SHIRT_TAB_IDS.FRONT;

  const contentComponents = {
    [MENU_IDS.AI_DESIGN]: <AiDesignContent currentSide={currentSide} />,
    [MENU_IDS.VECTOR_ARTS]: <VectorArtsContent />,
    [MENU_IDS.LIBRARY]: <LibraryContent currentSide={currentSide} />,
    [MENU_IDS.UPLOAD_IMPORT]: (
      <UploadContent
        currentSide={currentSide}
        activeTab={activeTab}
        uploadArtwork={uploadArtwork}
        deleteArtwork={deleteArtwork}
      />
    ),
    [MENU_IDS.COMMUNITY_ART]: <CommunityArtContent currentSide={currentSide} />
  } as const;

  const renderContent = () =>
    contentComponents[activeMenu] || contentComponents[MENU_IDS.UPLOAD_IMPORT];

  return (
    <div className="relative flex h-full max-h-full flex-col overflow-hidden">
      <TabNavigation tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange} />

      <div className="relative my-2 box-border flex flex-1 overflow-hidden bg-white md:my-6">
        <div key={activeMenu} className="flex-1 overflow-hidden">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}
